<div class="card">
  <div class="card-header">
    <div class="d-flex flex-wrap justify-content-between align-items-center w-100">
      <h3 class="fw-bold my-2">{{ 'companyProfile.sponsors.title' | translate }}</h3>
      <app-button
        [variant]="'primary'"
        [label]="'companyProfile.sponsors.addSponsor' | translate"
        [iconClass]="'fa fa-plus'"
        (clicked)="openAddModal()"
      />
    </div>
  </div>
  <div class="card-body">
    @if (loading) {
      <div class="d-flex justify-content-center align-items-center py-10">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'companyProfile.sponsors.loading' | translate }}</span>
        </div>
      </div>
    } @else if (companySponsors.length === 0) {
      <div class="text-center py-15">
        <i class="fa fa-handshake fs-3x text-muted mb-5"></i>
        <h4 class="text-muted">{{ 'companyProfile.sponsors.noSponsors' | translate }}</h4>
        <p class="text-muted mb-5">{{ 'companyProfile.sponsors.noSponsorsHint' | translate }}</p>
        <app-button
          [label]="'companyProfile.sponsors.addSponsor' | translate"
          [variant]="'primary'"
          [iconClass]="'fa fa-plus'"
          (clicked)="openAddModal()"
        />
      </div>
    } @else {
      <div class="row g-6 g-xl-9">
        @for (companySponsor of companySponsors; track companySponsor.entry_id) {
          <div class="col-md-6 col-lg-4">
            <div class="sponsor-card card h-100">
              <div class="card-body text-center">
                <div class="sponsor-logo mb-3 d-flex justify-content-center">
                  @if (companySponsor.sponsor?.logo_url) {
                    <img [src]="companySponsor.sponsor?.logo_url" alt="Sponsor Logo" class="img-fluid" style="max-height: 80px; object-fit: contain;" />
                  } @else {
                    <div class="sponsor-logo-placeholder">
                      <i class="fa fa-building fs-2x"></i>
                    </div>
                  }
                </div>
                <h5 class="sponsor-name mb-2">{{ companySponsor.sponsor?.sponsor_name }}</h5>
                @if (companySponsor.sponsor?.sponsor_description) {
                  <p class="sponsor-description text-muted mb-0">{{ companySponsor.sponsor?.sponsor_description }}</p>
                }
              </div>
              <div class="card-footer bg-transparent border-top-0">
                <div class="d-flex justify-content-center gap-2">
                  <app-button
                    [variant]="'ghost'"
                    [iconClass]="'fa fa-edit'"
                    [size]="'sm'"
                    (clicked)="openEditModal(companySponsor.sponsor!)"
                  />
                  <app-button
                    [variant]="'ghost'"
                    [iconClass]="'fa fa-trash text-danger'"
                    [size]="'sm'"
                    (clicked)="deleteSponsor(companySponsor.sponsor!)"
                  />
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
